import { KeyType, Network, StoredKeyMetadata } from "@lit-protocol/wrapped-keys/src/lib/types"
import { NAMADA_KEY_TYPE } from "../constants"

export type ExtendedKeyType = KeyType | typeof NAMADA_KEY_TYPE
export type ExtendedNetwork = Network | 'namada'
export type ExtendedStoredKeyMetadata = Omit<StoredKeyMetadata, 'keyType'> & {
  keyType: ExtendedKeyType
}
// Defines the access control conditions types for the wrapped key generation.
export enum AccessControlConditionsType {
  // Restricted to the vault secret IPFS hashes
  VAULT = 'VAULT',
  // Restricted to the PKP address only
  PKP_SCOPED = 'PKP_SCOPED',
}